import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import Summary from "./Summary";
import NavigationMenu from "./NavigationMenu";
import Chart from "./Chart";
import { calculateTotalsForGender } from "../lib/utils.js";
import "../styles/ReachResults.css";
import { formatNumber, urlToImage } from "../lib/utils.js";
import HotKeys from "./HotKeys";
import { toggleView } from "../actions";
import track from "../lib/tracking"
import ContactPopup from "./ContactPopup";
import Cookies from "js-cookie";

type Props = {
  selectedTargets: [],
  selectedLocations: [],
  ageRange: any
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedLocations: state.selectedLocations,
    selectedTargets: state.selectedTargets,
    ageRange: state.ageRange,
    currentView: state.currentView,
    results: state.results
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    prevPage: () => dispatch(toggleView("age"))
  };
};

class ReachResultsContainer extends Component<Props, State> {
  state = {
    copypasting: false,
    url: "",
    popupOpen: false,
  };

  componentDidMount(){
    if(!Cookies.get("subscribed") && window.location.search == "" ){
      setTimeout(() => this.setState({popupOpen: true}),3000);
    }
  }

  onFormSubmited = () => {
    this.setState({popupOpen: false})
    Cookies.set("subscribed",true)
    
    window.dataLayer = window.dataLayer || []; 
    window.dataLayer.push({ 
      'event': 'autoEvent', 
      'category': 'Form Submit', 
      'action': 'Audience Calculator' 
    });
  }

  save = () => {
    this.props.db
      .collection("options")
      .add({
        locations: this.props.selectedLocations,
        targets: this.props.selectedTargets.reduce(
          (acc, ar, key) => ({ ...acc, [key]: ar }),
          {}
        ),
        ages: this.props.ageRange
      })
      .then(docRef => {
        window.history.pushState("", "", "?q=" + docRef.id);
        this.setState({ url: docRef.id });
        this.copy.select();
      })
      .catch(error => {
        console.error("Error adding document: ", error);
      });
    track("share_link_clicked")
  };

  render() {
    const byCountry = this.props.results.reduce((accumulator, value) => {
      if (accumulator[value.country]) {
        accumulator[value.country] = _.orderBy(
          [...accumulator[value.country], value],
          "name"
        );
      } else {
        accumulator[value.country] = [value];
      }
      return accumulator;
    }, {});
    let results = Object.keys(byCountry).reduce((array, key) => {
      array[key] = byCountry[key].reduce((accumulator, value) => {
        if (accumulator[value.name]) {
          accumulator[value.name] = {
            ...accumulator[value.name],
            [value.gender]: value.reach,
            country: value.country,
            label: value.name
          };
        } else {
          accumulator[value.name] = {
            [value.gender]: value.reach,
            country: value.country,
            label: value.name
          };
        }
        return accumulator;
      }, {});
      return array;
    }, {});

    if(this.state.popupOpen){
     results = [];
    }

    console.log(results)
    const graphData = _.map(results, (value,key) => (
      {
        country: key,
        data: {
          labels: Object.keys(value),
          datasets: [
            {
              label: "Female",
              data: _.map(value, o => o.female || 0),
              backgroundColor: [
                "#86c87f",
                "#86c87f",
                "#86c87f",
                "#86c87f",
                "#86c87f",
              ],
              borderWidth: 2,
              borderColor: [
                "#86c87f",
                "#86c87f",
                "#86c87f",
                "#86c87f",
                "#86c87f",
              ]
            },
            {
              label: "Male",
              data: _.map(value, o => o.male || 0),
              backgroundColor: [
                "#f5d862",
                "#f5d862",
                "#f5d862",
                "#f5d862",
                "#f5d862",
              ],
              borderWidth: 2,
              borderColor: [
                "#f5d862",
                "#f5d862",
                "#f5d862",
                "#f5d862",
                "#f5d862",
              ]
            },
          ]
        }
      }
    ));
    console.log(graphData)
    

    const keyMap = {
      prevPage: "arrowleft"
    };

    const handlers = {
      prevPage: this.props.prevPage
    };
    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className="column">
          <Summary />
          <hr className="separator" />

          <h1 className="title">Results</h1>
          <h2 className="sub-title">
            For more information about reaching and engaging your Audience
            {" "}
            <a target="_blank" href="https://gruvi.tv/contact-us">contact us</a>
            .
          </h2>
          <div
            className="cells"
            style={
              Object.keys(results).length < 3
                ? { flexDirection: "row" }
                : { flexDirection: "column" }
            }
          >
            <div className="cell cell--chart">
              <div>
                <Chart results={graphData} />
              </div>
            </div>
            <div
              className="cell cell--numbers"
              style={
                Object.keys(results).length < 3
                  ? { maxWidth: "320px" }
                  : { maxWidth: "100%" }
              }
            >
              <div className="results">
                <h2>Total audience reach</h2>
                <ul
                  className="results__column"
                  style={
                    Object.keys(results).length < 3
                      ? { flexDirection: "column" }
                      : { flexDirection: "row" }
                  }
                >
                  {Object.keys(results).map(key => (
                    <div className="country-results" key={key}>
                      <div className="country-name">{key}</div>
                      <div className="country__headers">
                        <span className="country__age">Age</span>
                        <span className="country__female">Female</span>
                        <span className="country__male">Male</span>
                      </div>
                      {Object.keys(results[key]).map((ageKey, index) => (
                        <div
                          key={
                            results[key][ageKey].label +
                              results[key][ageKey].country
                          }
                          className={
                            index % 2 == 0
                              ? "country__line"
                              : "country__line country__line--even"
                          }
                        >
                          <span className="country__age">{ageKey}</span>
                          <span className="country__female">
                            {formatNumber(results[key][ageKey].female)}
                          </span>
                          <span className="country__male">
                            {formatNumber(results[key][ageKey].male)}
                          </span>
                        </div>
                      ))}
                      <div className="country__totals">
                        <span className="country__age">Total: </span>
                        <span className="country__female" key="total-female">
                          {formatNumber(
                            calculateTotalsForGender(results[key], "female") ||
                              0
                          )}
                        </span>
                        <span className="country__male" key="total-male">
                          {formatNumber(
                            calculateTotalsForGender(results[key], "male") || 0
                          )}
                        </span>
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="share">
            <input
              ref={ref => this.copy = ref}
              className="copy-url"
              style={{ opacity: 0 }}
              value={
                this.state.url
                  ? window.location.host +
                      "/?q=" +
                      this.state.url
                  : ""
              }
            />
            <button className="navigator__button" onClick={this.save}>
              Create share link
            </button>
            {this.state.url &&
              <button
                className="navigator__button"
                onClick={() => {
                  this.copy.focus();
                  this.copy.select();
                  document.execCommand("copy");
                  this.setState({ copypasting: true });
                  setTimeout(() => this.setState({ copypasting: false }), 800);
                }}
              >
                {this.state.copypasting ? "Link copied to clipboard" : "Copy"}
              </button>}
          </div>
          <NavigationMenu prev="age" />
        </div>
        <ContactPopup display={this.state.popupOpen} onFormSubmited={this.onFormSubmited}/>
      </HotKeys>
    );
  }
}

const ReachResults = connect(mapStateToProps, mapDispatchToProps)(
  ReachResultsContainer
);
export default ReachResults;



// WEBPACK FOOTER //
// ./src/components/ReachResults.js